export default {
  de: {
    dashboard: 'Dashboard',
  },
};
